module.exports = __webpack_public_path__ + "img/apple-white.8800285a.svg";